import React from 'react';
import '../../../src/html.scss'
import { useHistory } from 'react-router-dom';

const PricacyPolicy = () => {
    let history = useHistory()
    const goback = () => {
        history.goBack()
    }
    return (
        <div className="article">
            <h2 className='header'><span className='back' onClick={goback}>&lt;</span>私隱政策</h2>
            <p><strong>Dreamehome私隱政策</strong></p>
            <p><strong>引言</strong></p>
            <p>
                “Dreamehome”業務是由追覓創新科技（蘇州）有限公司、及其關聯公司（以下稱「我們」或「追覓」）運營的，爲您提供智能硬件設備控制和管理服務的平台（或服務）。我們理解並清楚個人信息對您的重要性，並將盡全力保護您的個人信息安全。我們將按業界公認的安全標準，採取相應的安全保護措施來保護您的個人信息。
            </p>
            <p>因此，請您在使用我們的產品（或服務）前，仔細閱讀並瞭解本《Dreamehome私隱政策》。</p>
            <p>如您是未成年人，請在監護人同意的情況下使用本應用程式並同意相關應用程式服務條款。</p>
            <p>
                本私隱政策在制定時充分考慮到您的需求，您全面瞭解我們的個人信息收集和使用慣例，同時確保您最終能掌握提供給我們的個人信息，這一點至關重要。本私隱政策規定我們如何收集、使用、披露、處理和存儲您使用我們的App時提供給我們的信息。我們將嚴格遵守本私隱政策來使用這些信息。
            </p>
            <p>本私隱政策將幫助您瞭解以下內容：</p>
            <p>1、我們收集哪些信息以及如何使用信息</p>
            <p>2、我們如何使用 Cookie 和同類技術</p>
            <p>3、我們如何委託處理、共享、轉讓和公開披露您的個人信息</p>
            <p>4、我們如何存儲和保護您的個人信息</p>
            <p>5、您的權利</p>
            <p>6、數據跨境傳輸</p>
            <p>7、聯繫我們</p>
            <p>8、本私隱政策如何更新</p>
            <p>附表一：第三方SDK詳情</p>
            <p>
                最後，我們的目的是給予您最好的用戶體驗，如您對本私隱政策存在任何疑問，我們設立了專門的私隱處理部門和人員，您可以通過本私隱政策第七部分與之取得聯繫。我們將根據各國政策和法律規定的時間來給予回復。如您不滿意我們的回復，特別是當您認爲我們的個人信息處理行爲損害了您的合法權益時，您還可以通過向有管轄權的法院提起訴訟、向政府監管機構投訴等外部途徑進行解決。
            </p>
            <p><strong>一、我們收集哪些信息以及如何使用信息</strong></p>
            <p>個人信息是指以電子或者其他方式記錄的能夠通過信息本身或通過關聯其他信息後能夠識別特定個人的各種數據。</p>
            <p>
                個人敏感信息是指一旦洩露、非法提供或濫用可能危害人身和財產安全、極易導致個人名譽、身心健康受到損害或歧視性待遇等的個人信息。包括但不限於身份證號碼、個人生物識別信息、銀行帳號、財產信息、行蹤軌跡、交易信息、14歲以下（含）兒童的個人信息等。
            </p>
            <p>我們收集個人信息的主要目的在於向您提供產品和/或服務，並且保證我們遵守適用的相關法律、法規及其他規範性文件。您有權自行選擇是否提供該信息，但多數情況下，如果您不提供，我們可能無法向您提供相應的服務，也無法回應您遇到的問題。
            </p>
            <p><strong>（一）Dreamehome基礎服務收集和處理您個人信息的情形</strong></p>
            <p><strong>（1） Dreamehome應用程式對智能硬件設備連接和管理</strong></p>
            <p>
                爲了給您提供Dreamehome的服務，使您可以安全地連接、管理智能硬件設備，我們可能會收集您的Wi-Fi信息、位置信息、登錄帳號信息、手機相關信息、智能硬件設備相關信息，以及追覓帳號和智能硬件設備的關聯信息。這些信息將用於爲您提供智能硬件設備快連、連接、發現附近設備和設備管理的功能。上述各項信息，詳細列舉如下：
            </p>
            <p>
                登錄帳號信息：您的追覓帳號用戶名、密碼、暱稱、頭像、郵箱、手機號。其中用戶名、密碼、手機號、郵箱屬於個人敏感信息，收集此類信息的目的是登錄追覓帳號服務器認證用戶身份，獲取Dreamehome帳號訪問服務器的權限。您輸入的帳號用戶名和登錄密碼認證信息將會加密傳輸到追覓帳號服務器進行登錄認證，
            </p>
            <p>手機相關信息：硬件設備標識(IMEI/OAID, Mac地址, Android
                ID)、手機型號、系統版本信息、系統語言、手機所設置的國家或地區、手機屏幕尺寸及分辨率、CPU及顯示設備相關信息。收集此類信息的目的是爲了使Dreamehome應用能夠連接智能硬件設備。</p>
            <p>
                智能硬件設備的信息：智能硬件設備的名稱、型號、版本、生產廠家、設備標識符、MAC地址、IP地址、設備運行狀態、自定義屬性、設置參數、業務事件和設備控制及使用記錄。我們收集此類信息的目的是綁定智能硬件設備，對設備進行控制和管理，以及設置設備屬性和參數，查看設備工作狀態和歷史記錄。
            </p>
            <p><strong>（2） Dreamehome應用程式和智能硬件設備的升級：</strong></p>
            <p>
                爲了使您持續享受最新的Dreamehome的服務，我們可能會使用您Dreamehome應用程式的版本信息、手機型號用於爲您提供Dreamehome應用程式的升級服務。同時，我們可能收集您已連接的智能硬件設備列表和版本號信息，用於爲您提供智能硬件設備的升級功能，以確保您可以使用最新版本的服務（包括固件版本）。Dreamehome衹提供智能硬件設備的升級途徑，智能硬件設備固件版本由智能硬件設備的生產廠商提供，生產廠商對版本質量和升級結果負責。
            </p>
            <p>若您不提供這類信息，將無法升級Dreamehome應用程式和智能硬件設備固件的新版本。</p>
            <p><strong>（3）在綫問題反饋：</strong></p>
            <p>
                爲了幫助您更有效的解決Dreamehome應用程式、智能硬件設備可能出現的問題，我們提供給您在綫問題反饋的渠道，爲了實現上述功能，我們需要收集您的以下信息：Dreamehome應用程式和設備的日誌信息、您反饋的聯繫方式和問題描述、問題現象圖片及視頻。其中應用程式和設備的日誌信息中會包含設備狀態、傳感器設備感知到的信息、設備操作記錄、設備標識符等，收集此類信息的目的是分析和定義問題原因；收集您的聯繫方式的目的是爲了追蹤回訪，瞭解問題是否完全解決，或者與您聯繫，希望您補充必要的其他信息。
            </p>
            <p>我們將按照以下方式使用您的個人信息：僅用於反饋問題的定義與解決，不用於個人信息的展示，不將此類信息用於推送商業廣告。若您不提供這類信息，將無法對您反饋的問題進行有效的定義和解決。</p>
            <p><strong>（二）我們在爲您提供Dreamehome基本服務以外的收集和處理您個人信息的情形</strong></p>
            <p>
                Dreamehome除基本服務會使用到您的個人信息以外，我們的以下附加功能中也可能會收集和使用您的個人信息。如果您不提供這些個人信息，您依然可以使用Dreamehome的基本服務，但您可能無法使用這些可以爲您所帶來便利的附加功能。這些附加功能包括：
            </p>
            <p><strong>用戶體驗改善計劃：</strong></p>
            <p>爲改善用戶體驗，我們需要收集您的以下信息：Dreamehome的日誌，其中包含經過加密處理後的關鍵流程日誌、事件日誌、故障日誌、業務事件、App各個界面的使用情況等，日誌中不會記錄您的敏感信息。</p>
            <p>我們將按照以下方式使用您的個人信息：自動採集上述信息並上傳到服務器，分析日誌信息診斷設備運行狀態並分析App使用情況。</p>
            <p>如果您不提供這些信息，Dreamehome將無法及時改善您的用戶體驗，但這並不會影響使用本服務的基本功能。</p>
            <p> <strong>（三）我們從第三方獲得您個人信息的情形</strong></p>
            <p>在一些法律允許的情況下，我們可能從第三方處獲得您的個人信息。例如：</p>
            <p>1、在您授權的前提下，在第三方智能硬件設備管理業務中，我們將與第三方服務提供商進行合作，其中涉及我們從第三方服務提供商處獲取您的個人信息。在第三方設備管理業務中，我們將在您綁定第三方帳號的條件下獲取您的以下個人信息：</p>
            <p>第三方帳號的信息，包括您的暱稱、頭像，用於在Dreamehome應用程式中顯示；</p>
            <p>設備及網絡信息，包括設備標識符、MAC地址、設備序列號，用於識別當前所工作的設備以及進行設備安全控制。</p>
            <p>
                如我們在開展業務時需進行的個人信息處理活動超出您原本向第三方服務提供商提供個人信息時的授權同意範圍，我們將在處理您的該等個人信息前，徵得您的明示同意。此外，我們也將會嚴格遵守相關法律法規的規定，並要求第三方服務提供商保障其提供的信息的合法性。
            </p>
            <p><strong>（四）非個人信息</strong></p>
            <p>
                我們還可能收集其他無法識別到特定個人的信息（即不屬於個人信息的信息），例如您使用特定服務時產生的統計類數據，如用戶的操作行爲（包括點擊、頁面跳轉、瀏覽時間）。收集此類信息的目的在於改善我們向您提供的服務。所收集信息的類別和數量取決於您如何使用我們產品和/或服務。
                我們會將此類信息匯總，用於幫助我們向客戶提供更有用的信息，瞭解客戶對我們網站、產品和服務中的哪些部分最感興趣，以便我們優化我們的服務界面。就本私隱政策而言，匯總數據被視爲非個人信息。如果我們將非個人信息與個人信息結合使用，則在結合使用期間，此類信息將被視爲個人信息。
            </p>
            <p><strong>二、我們如何使用 Cookie 和同類技術</strong></p>
            <p>爲確保Dreamehome的正常運轉，我們會在您的設備上存儲名爲Cookie的小數據文件。Cookie 通常包含標識符、站點名稱以及一些號碼和字符。借助於Cookie，Dreamehome能夠存儲您的網站登錄帳號、偏好等數據。
            </p>
            <p>我們不會將Cookie用於本聲明所述目的之外的任何用途。您可根據自己的偏好管理或刪除Cookie。但如果您這麼做，在某些情況下可能會影響您安全訪問Dreamehome，且可能在每一次訪問Dreamehome時都需親自更改用戶設置。
            </p>
            <p><strong>三、</strong><strong>我們如何委託處理、共享、轉讓和公開披露您的個人信息？</strong></p>
            <p><strong>（一）委託處理</strong></p>
            <p>在一般情況下，追覓可能會委託其他公司代表我們處理您的個人信息。例如代表我們與您聯繫、發送電子郵件或者爲您提供技術支持的公司，這些公司衹能將您的個人信息用於代表我們向您提供服務。</p>
            <p>我們會與被委託方簽署嚴格的保密協議或個人信息處理條款，要求他們按照本私隱政策以及採取相關的保密和安全措施來處理個人信息。</p>
            <p><strong>（二）共享</strong></p>
            <p>一般情況下，我們不會對外共享您的個人信息，但以下情況除外：</p>
            <p>1、獲得您的明確同意後，我們會向您指定的第三方共享您授權範圍內的信息；包括應您的請求，將您的智能家居產品的信息和配置等內容共享給您的親友，以幫助您的親友快速通過他們的終端設備使用本軟件及服務。</p>
            <p>
                2、Dreamehome服務中部分服務內容由第三方服務提供商提供，爲此我們需要向第三方服務提供商提供您的部分個人信息，例如網站托管、數據分析、支付和信用卡處理、基礎設施供應、IT服務、客戶支持服務、電子郵件發送服務以及其他類似服務，從而確保他們能夠爲我們提供服務。
            </p>
            <p>3、向直接或間接爲您提供智能硬件設備和/或您用來訪問和使用我們網站和服務的網絡和系統的客戶以及其他業務合作夥伴披露您的個人信息。</p>
            <p>
                4、當發生重組、合併、出售、合資、讓渡、轉讓或其他處置我們所有或部分業務、資產或股票（包括但不限於與任何破產或類似程序相關的上述情況）的情況時，向附屬公司或其他第三方披露您的個人信息。在這種情況下，您將通過電子郵件和/或我們的網站收到關於所有權變更、個人信息新的使用方式不兼容以及有關個人信息選擇的明確通知。
            </p>
            <p>
                5、在我們認爲必要或適當的情況下：（a）遵守適用的法律法規；（b）遵守法律程序；（c）響應公共機構和政府當局的要求，包括您居住的國家/地區以外的公共機構和政府當局；（d）履行我們的條款和條件；（e）保護我們的運營、業務和系統；（f）保護我們和/或包括您在內的其他用戶的權利、私隱、安全或財產；以及（g）尋求可用的補救措施或限制我們可能需要提供的損害賠償。
            </p>
            <p>6、向公司旗下的子公司或附屬公司披露您的個人信息，以定期開展業務活動。</p>
            <p>7、
                我們會通過應用程式接口（API）、軟件工具開發包（SDK）與第三方進行必要的數據共享，不同版本的第三方SDK會有所不同，一般包括第三方帳號登錄類、分享類、第三方支付類、廠商推送類、統計類等，我們會對第三方進行嚴格的安全檢測並約定數據保護措施。附件一爲我們授權接入的第三方SDK詳情，請仔細閱讀。我們的私隱政策不適用於第三方提供的產品或服務。當您使用這些產品或服務時，也可能收集您的信息。因此，我們強烈建議您花時間閱讀該第三方的私隱政策，就像閱讀我們的政策一樣。我們不對第三方如何使用他們向您收集的個人信息負責，也不能控制其使用。我們的私隱政策不適用通過我們的服務鏈接的其他網站。您需自行獨立判斷您與鏈接網站的互動行爲。在您首次進入第三方頁面前，第三方服務提供商會向您展示相關的協議和私隱聲明，請您仔細閱讀這些協議和私隱聲明。
            </p>
            <p><strong>（三）轉讓</strong></p>
            <p>追覓不會將您的個人信息轉讓給任何公司、組織和個人，但以下情況除外：</p>
            <p>1. 在獲取明確同意的情況下轉讓：獲得您的明確同意後，我們會向其他方轉讓您的個人信息；</p>
            <p>2. 在涉及合併、收購或破產清算時，如涉及到個人信息轉讓，我們會要求新的持有您個人信息的公司、組織繼續受本聲明的約束，否則我們將要求該公司、組織重新向您徵求授權同意。</p>
            <p><strong>（四）公開披露</strong></p>
            <p>我們僅會在以下情況下，公開披露您的個人信息：</p>
            <p>1、獲得您明確同意後；</p>
            <p>2、基於法律的披露：在符合法律或基於法律程序、訴訟或政府主管部門強制性要求的情況下，我們可能會公開披露您的個人信息。</p>
            <p><strong>四、我們如何存儲和保護您的個人信息 </strong></p>
            <p>
                我們基於本私隱政策中所述的信息收集的目的所必需的期間，或者遵守適用的相關法律要求保留個人信息。個人信息在完成收集目的，或在我們確認您的刪除或註銷申請後，或我們終止運營相應產品或服務後，我們將停止保留，並做刪除或匿名化處理。如果是出於公眾利益、科學、歷史研究或統計的目的，我們將基於適用的法律繼續保留相關數據，即使進一步的數據處理與原有的收集目的無關。
            </p>
            <p>在Dreamehome業務中，您的個人數據具體留存時間如下：</p>
            <p>對於存儲在Dreamehome應用本地的數據，當您卸載Dreamehome應用或者清除Dreamehome應用數據時，所有存儲的數據將會被立即刪除。</p>
            <p>對於存儲在服務器上的Dreamehome智能硬件設備和業務數據，當您刪除智能硬件設備、拒絕同意Dreamehome私隱政策並停止使用Dreamehome服務時，所有存儲的數據將會被立即刪除。</p>
            <p>對於存儲在服務器上的業務日誌、統計數據和歷史記錄，我們會在不定期清理服務器數據時刪除，數據保存時間通常不長於2年。</p>
            <p>此外，當我們的產品或服務發生停止運營的情形時，我們將以推送通知、公告等形式通知您，並在合理的期限內刪除您的個人信息或進行匿名化處理。</p>
            <p><strong>五、您的權利</strong></p>
            <p><strong>（一）訪問、更正、刪除您的個人信息</strong></p>
            <p>根據您所適用的國家或地區法律法規，您有權要求訪問、更正、刪除我們持有的與您相關的任何個人信息（以下簡稱請求）。請致信或者通過訪問Dreamehome聯繫我們。
                大多數法律要求個人信息主體提出的請求應遵循特定要求，本私隱政策要求您的請求應當符合以下情形：</p>
            <p>通過我們專門的請求渠道，並且出於保護您的信息安全的考慮，您的請求應當是書面的（除非當地法律明確承認口頭申請）；</p>
            <p>提供足夠的信息使我們可以驗證您的身份，確保請求人是所請求信息主體本人或合法授權人；</p>
            <p>一旦我們獲得充分信息確認可處理您的請求時，我們將在適用數據保護法律規定的時間內對您的請求做出回應。具體而言：</p>
            <p>基於您的要求及適用法律規定，我們可免費提供一份我們已收集並處理的關於您的個人信息記錄，如您提出對於相關信息的其他請求，我們可能會基於相關適用法律，並結合實際的管理成本向您收取一筆合理的費用。</p>
            <p>如果您認爲我們持有的關於您的任何信息是不正確或不完整的，可要求基於使用目的更正或完善個人信息。</p>
            <p>
                根據您適用的法律法規，您可能有權要求我們刪除您的個人數據。我們將會根據您的刪除請求進行評估，若滿足相應規定，我們將會採取包括技術手段在內的相應步驟進行處理。當您或我們協助您刪除相關信息後，因爲適用的法律和安全技術，我們可能無法立即從備份系統中刪除相應的信息，我們將安全地存儲您的個人信息並將其與任何進一步處理隔離，直到備份可以清除或實現匿名。例如，根據《中華人民共和國電子商務法》，您的商品和服務信息、交易信息保存時間自交易完成之日起不得少於三年。
            </p>
            <p>
                我們有權拒絕處理無實質意義/糾纏式重復的請求、損害他人私隱權的請求、極端不現實的請求，要求不相稱的技術工作，以及根據當地法律無需給予的請求，已經公之於眾的信息，保密條件下給出的信息。如果我們認爲刪除數據或訪問數據的請求的某些方面可能會導致我們無法出於前述反欺詐和安全目的合法使用數據，可能也會予以拒絕。
            </p>
            <p><strong>（二）撤銷同意</strong></p>
            <p>
                您可以通過提交請求撤銷同意，包括收集、使用和/或披露我們掌握或控制的您的個人信息。根據您所使用的具體服務，可以通過本私隱政策第七節中的聯繫方式聯繫我們進行相關操作。我們將會在您做出請求後的合理時間內處理您的請求，並且會根據您的請求，在此後不再收集、使用和/或披露您的個人信息。
            </p>
            <p>請注意，根據您授權我們處理信息的範圍，您撤銷同意可能導致您不能享受Dreamehome或其智能硬件產品的服務。但您撤回同意或授權的決定，不會影響此前基於您的授權而開展的個人信息處理。</p>
            <p>您可以訪問通過請求撤銷同意或進入Dreamehome頁面進行更改以退出用戶體驗改善計劃，撤回對此項個人信息使用的同意。</p>
            <p><strong>（三）註銷Dreamehome帳號</strong></p>
            <p>
                您可以通過訪問「我的」——「帳號設置」——「註銷帳號」進行註銷Dreamehome帳號。如您希望註銷Dreamehome帳號，由於註銷Dreamehome帳號的操作將使您無法使用Dreamehome及其全綫智能硬件產品和服務，請您謹慎操作。我們爲了保護您或他人的合法權益會結合您對Dreamehome各智能硬件產品和服務的使用情況判斷是否支持您的註銷請求。
            </p>
            <p><strong>六、數據跨境傳輸</strong></p>
            <p>
                由於我們通過遍布全球的資源和服務器提供產品或服務，這意味著，在獲得您的授權同意後，您的個人信息可能會被轉移到您使用產品或服務所在國家/地區的境外管轄區，或者受到來自這些管轄區的訪問。您的信息可能傳輸到的國家/地區的數據保護措施和其他法律可能不像您所在國家/地區那樣全面。在此類情況下，我們將根據各個管轄區的適用法律採取適當以及合法的措施，以確保您的個人信息繼續受到保護。
            </p>
            <p>特別說明：</p>
            <p>如果您是歐洲經濟區 (EEA) 居民，且您的個人信息在 EEA
                境外傳輸，我們將：在歐盟委員會已確定可以提供足夠保護等級的區域處理您的個人信息；或者實施適當的防護措施來保護您的個人信息，包括按照適用的傳輸機制進行傳輸，例如歐盟委員會的標準合約條款。</p>
            <p><strong>七、聯繫我們</strong></p>
            <p>
                如果您對本私隱政策有任何意見或問題，或者您對我們收集、使用或披露您的個人信息有任何問題，請通過下方地址或通過訪問「我的」——「關注與反饋」聯繫我們，並提及「私隱政策」。針對您關於個人信息相關的權利請求、問題咨詢等時，我們有專業的團隊解決你的問題。如果你的問題本身涉及比較重大的事項，我們可能會要求你提供更多信息。如果您對收到的答復不滿意，您可以將投訴移交給所在司法轄區的相關監管機構。如果您咨詢我們，我們會根據您的實際情況，提供可能適用的相關投訴途徑的信息。
            </p>
            <p>郵箱地址：</p>
            <ul>
                <li>中國區聯繫方式：<a className="page"
                    href="mailto:privacy@dreame.tech">privacy@dreame.tech</a></li>
                <li>新加坡DPO聯繫方式：<a className="page"
                    href="mailto:dpo.sg@dreame.tech">dpo.sg@dreame.tech</a></li>
                <li>歐盟代表聯繫方式：<a className="page"
                    href="mailto:representative.dreame@herrero.es">representative.dreame@herrero.es</a></li>
            </ul>
            <p>聯繫電話：400-875-9511</p>
            <p>網址：<a className="page"
                href="https://www.dreametech.com/ ">https://www.dreametech.com/ </a> </p>
            <p><strong>八、本私隱政策如何更新</strong></p>
            <p>追覓保留適時更新本政策的權利，當政策發生變更時，我們會通過彈窗方式或其他顯著的方式向您展示變更後的政策。衹有在獲取您的同意後，我們才會按照更新後的政策收集、使用和存儲您的個人信息。</p>
            <p>本政策自更新之日起生效。</p>
            <p>最近更新日期：2021年8月28日</p>
            <p>附表一：第三方<strong>SDK</strong>詳情</p>
            <p>*爲了給您提供更專業、安全的基礎和附加功能服務，Dreamehome會接入第三方SDK產品。目前Dreamehome中存在的第三方SDK產品披露如下：</p>
            <div className='tableStyle'>
            <table>
                <tr>
                    <td>
                        <p>SDK服務</p>
                    </td>
                    <td>
                        <p>具體功能</p>
                    </td>
                    <td>
                        <p>獲取信息</p>
                    </td>
                    <td>
                        <p>第三方私隱政策</p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>友盟統計分析SDK</p>
                    </td>
                    <td>
                        <p>統計分析</p>
                    </td>
                    <td>
                        <p>設備標識符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)、地理位置</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>友盟消息推送SDK</p>
                    </td>
                    <td>
                        <p>消息推送</p>
                    </td>
                    <td>
                        <p>設備標識符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)、地理位置</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>友盟社會化分享SDK</p>
                    </td>
                    <td>
                        <p>第三方分享</p>
                    </td>
                    <td>
                        <p>設備標識符(IMEI/Mac/android ID/IDFA/OPENUDID/GUID、SIM 卡 IMSI 信息)、地理位置</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.umeng.com/policy">https://www.umeng.com/policy</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>Agora SDK</p>
                    </td>
                    <td>
                        <p>連麥、視頻流播放</p>
                    </td>
                    <td>
                        <p>設備信息、網絡狀態、相機、麥克風、讀寫存儲空間</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.agora.io/cn/privacy-policy/">https://www.agora.io/cn/privacy-policy/</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>華爲推送SDK</p>
                    </td>
                    <td>
                        <p>推送</p>
                    </td>
                    <td>
                        <p>設備標識信息</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169">https://developer.huawei.com/consumer/cn/doc/start/agreement-0000001052728169</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>小米推送SDK</p>
                    </td>
                    <td>
                        <p>推送</p>
                    </td>
                    <td>
                        <p>設備標識信息、設備型號、網絡類型、設備存儲、設備運行進程信息、應用程式版本、SDK版本</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://dev.mi.com/console/doc/detail?pId=1822">https://dev.mi.com/console/doc/detail?pId=1822</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>OPPO推送SDK</p>
                    </td>
                    <td>
                        <p>推送</p>
                    </td>
                    <td>
                        <p>設備標識信息</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://open.oppomobile.com/wiki/doc#id=10194">https://open.oppomobile.com/wiki/doc#id=10194</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>VIVO推送SDK</p>
                    </td>
                    <td>
                        <p>推送</p>
                    </td>
                    <td>
                        <p>設備標識信息</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://dev.vivo.com.cn/documentCenter/doc/366">https://dev.vivo.com.cn/documentCenter/doc/366</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>微信SDK</p>
                    </td>
                    <td>
                        <p>微信第三方登錄、微信分享</p>
                    </td>
                    <td>
                        <p>設備標識信息、網絡信息</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>QQ SDK</p>
                    </td>
                    <td>
                        <p>分享</p>
                    </td>
                    <td>
                        <p>設備標識信息、網絡信息</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://privacy.qq.com/">https://privacy.qq.com/</a></p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>微博SDK</p>
                    </td>
                    <td>
                        <p>微博第三方登錄、微博分享</p>
                    </td>
                    <td>
                        <p>設備標識信息、網絡信息</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE">https://open.weibo.com/wiki/%E5%BC%80%E5%8F%91%E8%80%85%E5%8D%8F%E8%AE%AE</a>
                        </p>
                    </td>
                </tr>
                <tr>
                    <td>
                        <p>AppleID SDK</p>
                    </td>
                    <td>
                        <p>使用Apple ID登錄</p>
                    </td>
                    <td>
                        <p>Apple ID</p>
                    </td>
                    <td>
                        <p><a className="page"
                            href="https://www.Apple.com/legal/privacy/szh/">https://www.Apple.com/legal/privacy/szh/</a></p>
                    </td>
                </tr>
            </table>
            </div>
            <div className='height'></div>
        </div>
    )
}

export default PricacyPolicy